import request from '@/utils/request'


//查询金币列表
export function queryGoldRecode(data) {
  return request({
    url: '/admin/card/gold/list',
    method: 'post',
    data: data
  })
}

export function saveGoldRecode(data) {
  return request({
    url: '/admin/card/gold/save',
    method: 'post',
    data: data
  })
}

export function getTotalGold(params) {
  return request({
    url: '/admin/card/gold/getTotalGold/'+params.cardId,
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/goldRecord.js